// This file will be imported in index.js to run before the app starts

// Add a circuit breaker to prevent potential runaway
let isProcessingUpdate = false;

// Immediately check for active training cooldowns on page load
(function checkCooldownOnLoad() {
  console.log('🔄 Emergency cooldown manager initializing...');
  
  // Define helper functions
  const updateDOM = (cooldownDateStr) => {
    // ADDED: Circuit breaker to prevent recursive updates
    if (isProcessingUpdate) {
      console.log('Already processing a cooldown update, skipping...');
      return false;
    }
    
    try {
      isProcessingUpdate = true;
      
      const cooldownDate = new Date(cooldownDateStr);
      const now = new Date();
      const diffMs = cooldownDate - now;
      
      if (diffMs <= 0) {
        isProcessingUpdate = false;
        return false; // Skip if cooldown already passed
      }
      
      console.log('🔄 Active cooldown found, updating DOM:', cooldownDateStr);
      
      // Format time remaining
      const minutes = Math.floor(diffMs / 60000);
      const seconds = Math.floor((diffMs % 60000) / 1000);
      
      // Check if style already exists to avoid duplicates
      if (!document.getElementById('emergency-cooldown-styles')) {
        // Set styles to be applied immediately
        const styleTag = document.createElement('style');
        styleTag.id = 'emergency-cooldown-styles';
        styleTag.textContent = `
          .nav-item[href="/training"] {
            background-color: rgba(255, 152, 0, 0.15) !important;
            border-left: 3px solid #ff9800 !important;
            opacity: 0.6;
            cursor: not-allowed !important;
            pointer-events: none;
          }
          .nav-item[href="/training"] .notification-dot {
            background-color: #ff6b6b !important;
          }
          #emergency-cooldown-tracker {
            position: fixed;
            top: 0;
            right: 0;
            background-color: rgba(255, 152, 0, 0.9);
            color: white;
            padding: 5px 10px;
            font-size: 12px;
            font-weight: bold;
            z-index: 9999;
          }
        `;
        document.head.appendChild(styleTag);
      }
      
      // Create or update visual indicator
      let tracker = document.getElementById('emergency-cooldown-tracker');
      if (!tracker) {
        tracker = document.createElement('div');
        tracker.id = 'emergency-cooldown-tracker';
        document.body.appendChild(tracker);
      }
      tracker.textContent = `Training Cooldown: ${minutes}m ${seconds}s`;
      
      // Only set one timer at a time - clear existing one if present
      if (window.__EMERGENCY_COOLDOWN_TIMER) {
        clearInterval(window.__EMERGENCY_COOLDOWN_TIMER);
      }
      
      // Set timer to update every second
      window.__EMERGENCY_COOLDOWN_TIMER = setInterval(() => {
        const updatedDiff = cooldownDate - new Date();
        if (updatedDiff <= 0) {
          clearInterval(window.__EMERGENCY_COOLDOWN_TIMER);
          window.__EMERGENCY_COOLDOWN_TIMER = null;
          document.getElementById('emergency-cooldown-tracker')?.remove();
          document.getElementById('emergency-cooldown-styles')?.remove();
          return;
        }
        
        const updatedMinutes = Math.floor(updatedDiff / 60000);
        const updatedSeconds = Math.floor((updatedDiff % 60000) / 1000);
        const trackerEl = document.getElementById('emergency-cooldown-tracker');
        if (trackerEl) {
          trackerEl.textContent = `Training Cooldown: ${updatedMinutes}m ${updatedSeconds}s`;
        }
      }, 1000);
      
      // Use a more stable way to hook into React's lifecycle - throttled
      if (window.EMERGENCY_UPDATE_TRAINING_COOLDOWN && !window.__LAST_EMERGENCY_CALL) {
        window.__LAST_EMERGENCY_CALL = Date.now();
        window.EMERGENCY_UPDATE_TRAINING_COOLDOWN(cooldownDate);
        
        // Reset the timestamp after some time
        setTimeout(() => {
          window.__LAST_EMERGENCY_CALL = null;
        }, 2000);
      }
      
      isProcessingUpdate = false;
      return true;
    } catch (err) {
      console.error('Error in emergency DOM update:', err);
      isProcessingUpdate = false;
      return false;
    }
  };
  
  // Add a delay before checking to prevent conflicts with React initialization
  setTimeout(() => {
    // Check cooldowns from multiple sources
    const storedCooldown = localStorage.getItem('training_cooldown');
    if (storedCooldown) {
      updateDOM(storedCooldown);
    }
    
    // Set up DOM mutation observer to update as soon as sidebar renders
    // But with a circuit breaker to prevent excessive processing
    let lastObserverUpdate = 0;
    const OBSERVER_THROTTLE = 1000; // 1 second between updates
    
    const observer = new MutationObserver((mutations) => {
      const now = Date.now();
      if (now - lastObserverUpdate < OBSERVER_THROTTLE) {
        return;
      }
      
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          const trainingLink = document.querySelector('.nav-item[href="/training"]');
          if (trainingLink) {
            lastObserverUpdate = now;
            
            // Check if we need to apply cooldown styling
            if (storedCooldown) {
              const cooldownDate = new Date(storedCooldown);
              if (cooldownDate > new Date()) {
                // Add cooldown styling immediately
                trainingLink.classList.add('disabled', 'cooldown-active');
                const dot = trainingLink.querySelector('.notification-dot');
                if (dot) dot.className = 'notification-dot cooldown';
              }
            }
            break; // Exit the loop once we've found and processed the link
          }
        }
      }
    });
    
    // Start observing the document with more limited scope
    observer.observe(document.body, { childList: true, subtree: true });
    
    // Add a circuit breaker to localStorage event listener
    let lastStorageUpdate = 0;
    const STORAGE_THROTTLE = 500; // 500ms between updates
    
    window.addEventListener('storage', (event) => {
      const now = Date.now();
      if (now - lastStorageUpdate < STORAGE_THROTTLE) {
        return;
      }
      
      if (event.key === 'training_cooldown' && event.newValue) {
        lastStorageUpdate = now;
        updateDOM(event.newValue);
      }
    });
  }, 200); // Slight delay to avoid initialization conflicts
})();

// Fix ESLint warning by assigning to a variable before exporting
const emergencyCooldownManager = {};
export default emergencyCooldownManager;
